import { Injectable } from '@angular/core';
import { map, BehaviorSubject, Observable, catchError } from 'rxjs';

import { CorporateUserCardType, GetCorporateUserCardByUserAndTargetGQL, GetCorporateUserCardsByUserGQL } from '@sifca-monorepo/widget-generator';

@Injectable({
  providedIn: 'root',
})
export class MobileCardService {
  private loadingCard: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private userCard: BehaviorSubject<CorporateUserCardType> = new BehaviorSubject(null);

  get loadingCard$(): Observable<boolean> {
    return this.loadingCard.asObservable();
  }

  get userCard$(): Observable<CorporateUserCardType> {
    return this.userCard.asObservable();
  }
  set userCard$(value: CorporateUserCardType) {
    this.userCard.next(value);
  }

  constructor(
    private getCorporateUserCardsByUserGQL: GetCorporateUserCardsByUserGQL,
    private getCorporateUserCardByUserAndTargetGQL: GetCorporateUserCardByUserAndTargetGQL,
  ) {}

  getCorporateUserCardsByUser(): Observable<CorporateUserCardType> {
    return this.getCorporateUserCardsByUserGQL
      .fetch(
        { userId: localStorage.getItem('aggregatorUser') }, // aggregator user
      )
      .pipe(
        map(({ data }: any) => {
          if (data) {
            this.userCard.next(data.getCorporateUserCardsByUser?.[0]);
            return data.getCorporateUserCardsByUser[0];
          }
        }),
      );
  }

  getCorporateUserCardByUserAndTarget(): Observable<CorporateUserCardType> {
    this.loadingCard.next(true);
    return this.getCorporateUserCardByUserAndTargetGQL.fetch({ target: { pos: localStorage.getItem('posId') } }).pipe(
      catchError(() => {
        this.loadingCard.next(false);
        return null;
      }),
      map(({ data }: any) => {
        this.loadingCard.next(false);
        if (data) {
          this.userCard.next(data.getCorporateUserCardByUserAndTarget?.[0]);
          return data.getCorporateUserCardByUserAndTarget[0];
        }
      }),
    );
  }
}
